import React from "react";
import {FooterPage} from "../../AppCore/Component/Layout/FooterPage";
import styles from "../assets/css/page.css";
import {DownloadButtonComponent} from "../../AppCore";

export const SuccessAgreementComponent = ({ downloadLink }) => {

  return (
    <React.Fragment>
          {/* Agreement paragraph */}
          <div className="row agreement-text">
            <div className="col-lg-12 col-sm-12 col-xs-12" style={{marginBottom: '10%'}}>
              <p className={styles.description}>
                Thank you for sending the agreement. One of our channel managers
                will be contacting you. You can download a copy of the agreement
                by clicking the button below.
              </p>

              <div className="div-btn-download">
                <DownloadButtonComponent
                  link={downloadLink}
                  label={"Download Agreement (PDF)"}
                  customClass={"btn btn-success btn-download"}
                />
              </div>
            </div>
          </div>

      <div className={`row ${styles.footer}`}>
        <div className={"col-sm-12"}>
          <FooterPage />
        </div>
      </div>
    </React.Fragment>
  );
};




// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Component/SuccessAgreementComponent.js